import React from "react"
import SectionHeader from "../../molecules/SectionHeader"
import Social from "../../atoms/Social"
import Clutch from "../../atoms/Clutch"
import Reactmarkdown from "react-markdown"
import handleCalendly from "../../../functions/handleCalendly"
import "./styles.scss"
const SocialsHero = ({
  children,
  subtitle,
  socials,
  url,
  clutchRating,
  numberOfReviews,
}) => {
  return (
    <>
      <section className="section section--socialsHero">
        <div className="wrapper--text">
          <div>
            <div className="socialsHero__title">
              <SectionHeader
                attributes={{
                  "data-sal": "slide-up",
                  "data-sal-easing": "ease",
                  "data-sal-duration": "1000",
                }}
                type="h1"
                subtitle={subtitle}
                url={url}
              >
                {children}
              </SectionHeader>
              <p className="socialsHero__paragraph">
                or{" "}
                <a
                  onClick={() => handleCalendly()}
                  className="link link--bordered"
                >
                  schedule a call
                </a>{" "}
                and share your story with us
              </p>
            </div>
            <div className="socialsHero__socials">
              {socials.map((social, i) => {
                return (
                  <Social
                    key={i}
                    to={social.socialLink}
                    type={social.socialName}
                  />
                )
              })}
            </div>
          </div>
          <div className="nda__container">
            <div className="nda">
              <h4 className="title nda__title">Need NDA first?</h4>
              <p className="nda__paragraph">
                We completely understand. Feel free to submit your NDA through
                the above email.
              </p>
            </div>
            <div className="nda__socials">
              {socials.map((social, i) => {
                return (
                  <Social
                    key={i}
                    to={social.socialLink}
                    type={social.socialName}
                  />
                )
              })}
            </div>
            <div className="nda__clutch">
              <Clutch rating={clutchRating} />
              <span>{numberOfReviews} reviews</span>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default SocialsHero
